// Lightweight CSV parser (no external deps). Handles:
// - Comma separated values
// - Double quoted fields with escaped quotes ""
// - Newlines inside quoted fields
// Returns: { headers: string[], rows: Array<object>, rawRows: string[][] }
export function parseCsv(text, { header = true } = {}) {
  const rows = [];
  let cur = '';
  let inQuotes = false;
  const pushCell = (arr) => { arr.push(cur); cur = ''; };
  let row = [];
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') { // escaped quote
          cur += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        cur += c;
      }
    } else {
      if (c === '"') {
        inQuotes = true;
      } else if (c === ',') {
        pushCell(row);
      } else if (c === '\n') {
        pushCell(row);
        rows.push(row);
        row = [];
      } else if (c === '\r') {
        // ignore, handle on \n
      } else {
        cur += c;
      }
    }
  }
  // flush last cell
  if (cur.length > 0 || row.length) {
    pushCell(row);
    rows.push(row);
  }
  if (!rows.length) return { headers: [], rows: [], rawRows: [] };
  let headers = [];
  let dataStart = 0;
  if (header) {
    headers = rows[0].map(h => h.trim());
    dataStart = 1;
  } else {
    headers = rows[0].map((_, idx) => `col_${idx + 1}`);
  }
  const objects = rows.slice(dataStart).filter(r => r.some(cell => cell?.trim())).map(r => {
    const obj = {};
    headers.forEach((h, i) => { obj[h] = (r[i] || '').trim(); });
    return obj;
  });
  return { headers, rows: objects, rawRows: rows };
}

export function mapEmployeeCsvRow(row) {
  // Expect headers like: fullName,email,department,position,site,employmentType
  return {
    fullName: row.fullName || row.name || '',
    email: row.email || '',
    department: row.department || row.dept || '',
    position: row.position || '',
    site: row.site || '',
    employmentType: row.employmentType || row.type || 'full-time'
  };
}
